import { Component, OnInit, ViewChild } from '@angular/core';
import { Routes, ActivatedRoute, Router } from '@angular/router';
import { IHeaderTitle } from 'app/shared/models/header-title';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AlertMessageComponent } from 'app/shared/components/alert-message/alert-message.component';
import { Location } from '@angular/common';
import { QuestionService } from 'app/question/services/question.service';
import { QuestionBankDetailsModel } from 'app/question/models/question-bank-details.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { QuestionBankQuestionListModel } from 'app/question/models/question-bank-question-list.model';

@Component({
    templateUrl: './question-bank-details.component.html',
    styleUrls: ['./question-bank-details.component.css']
})
export class QuestionBankDetailsComponent implements OnInit {
    questionBankDetailsModel: QuestionBankDetailsModel;
    errors: string[];
    headerTitle: IHeaderTitle;
    submitAttempt = false;
    @ViewChild(AlertMessageComponent, { static: false }) alertMessage: AlertMessageComponent;
    redirectRoutes: Routes;
    questionBankDetailsFormGroup: FormGroup;
    isEditMode = false;
    questionBankId: string;
    selectedQuestionBankId: string;
    questionBankQuestions: QuestionBankQuestionListModel[];

    constructor(
        private questionService: QuestionService,
        private activatedRoute: ActivatedRoute,
        private fb: FormBuilder,
		private location: Location,
        private router: Router,
        private modalService: NgbModal
    ) { }

    ngOnInit() {
        this.load();
    }

    load(): void {
        this.questionBankId = this.activatedRoute.snapshot.params['id'];
        this.questionService.getQuestionBank(this.questionBankId).subscribe(questionBankDetailsModel => {
            this.questionBankDetailsModel = questionBankDetailsModel;
            this.initializeForm(questionBankDetailsModel);
            this.headerTitle = {
                title: questionBankDetailsModel.name,
                breadcrumbs: [{ title: 'Question Banks', url: ['/question/questionbank'] }]
            };
            this.questionService.getQuestionBankQuestions(this.questionBankId).subscribe(
                questionBankQuestions => {
                    this.questionBankQuestions = questionBankQuestions;
                },
                error => this.errors = error.errorList
            );
        });
    }

    initializeForm(model: QuestionBankDetailsModel): void {
        this.questionBankDetailsFormGroup = this.fb.group(
            {
                id: [this.questionBankId],
                name: [model.name, Validators.required],
                nrOptionalQuestions: [model.nrOptionalQuestions, Validators.required]
            }
        );
    }

    toggleEditMode(): void {
        this.isEditMode = !this.isEditMode;
    }

    updateModule(): void {
        this.submitAttempt = true;
        if (this.questionBankDetailsFormGroup.valid) {
            const formValue = this.questionBankDetailsFormGroup.value;
            this.questionService.updateQuestionBank(formValue).subscribe(
                response => {
                    this.alertMessage.showMessage();
                },
                error => {
                    this.errors = error.errorList;
                }
            );
        }
    }

    successClicked($event: any): void {
        this.router.navigate(['./question/questionbank']);
    }

    onHide($event: any): void { }

    onBack($event: any): void {
        this.location.back();
    }

    deleteQuestionBank() {
        this.questionService.deleteQuestionBank(this.selectedQuestionBankId).subscribe(
            result => this.router.navigate(['./question/questionbank']),
            error => console.log(error)
        );
    }

    openCannotDeleteQuestionBank(content) {
        this.modalService.open(content);
    }

    questionBankQuestionsUpdated() {
        this.load();
    }
}
